import { environment } from './../../../environments/environment';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges
} from '@angular/core';
import { ProductModel } from '../models/product.model';
import { CategoryModel } from '../models/category.model';
import {ProdcutImageUtil} from '../../lib/product-image-util';
import {ImageUploadImageSetModel} from '../../image-admin/image-models/image-upload-image-set.model';

@Component({
  selector: 'app-product-card',
  template: `

  <div class="thumbnail text-center">
    <div *ngIf="showFamily" class="text-right">
      <p style="
      border-top: solid 1px #A50034 !important;
      border-left: solid 1px #A50034;
      border-bottom: solid 1px #A50034;
      color: #A50034;
      float: right !important;
      font-family: 'LGEIRegular';
      font-size:12px;
      line-height:16px;
      text-align:center;
      padding-right: 10px;
      padding-left: 10px;
      height: 18px;
      min-width: 104px;
      -webkit-border-top-left-radius: 5px;
      -webkit-border-bottom-left-radius: 5px;
      -moz-border-top-left-radius: 5px;
      -moz-border-bottom-left-radius: 5px;
      margin-bottom: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;"
      class="desctype">
      {{this.model.type}}
      </p>
    </div>
    <div style="height: 180px; text-align: center; clear: both;">
      <picture class="product-img-elem">
        <source [srcset]="this.hiresproductImage" media="(min-width: 1920px)" />
        <source [srcset]="this.desklargeproductImage" media="(max-width: 1919px) and (min-width: 1280x)" />
        <source [srcset]="this.desksmallproductImage" media="(max-width: 1279px) and (min-width: 1024px)" />
        <source [srcset]="this.tabletproductImage" media="(max-width: 1023px) and (min-width: 769px)" />
        <img [src]="this.phoneproductImage" alt="" />
      </picture>
    </div>
    <div style="height: 186px;">
    <h3 style="height: 25px !important;
      color: #4A4A4A !important;
      font-family: 'LGEIRegular';
      font-size: 18px !important;
      font-weight: bold !important;
      line-height: 25px !important;
      text-align: center !important;
      padding: 0px 15px 0px 15px;
      float: none;
      margin: 0 auto;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;">{{this.model.title}}</h3>
    <div style="height: 104px !important;
      padding: 5px 15px 5px 15px;
      color: #4A4A4A !important;
      font-family: 'LGEIRegular';
      font-size: 16px !important;
      line-height: 1.5em !important;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 0 auto;
      -webkit-line-clamp: 4;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-align: left !important;" [innerHTML]="this.isCommercial() ? this.model.description : this.model.resDescription"></div>
      <p style="display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; margin-top: 10px; "><a style="background-color: #A50034 !important; border-color: #A50034 !important; height: 32px; width: 125px; border-radius: 4px; display: flex; align-items: center; justify-content: center" class="btn btn-primary" href="{{productUmbracoUrl}}" attr.aria-label="Learn More about {{this.model.title}}">Learn More</a></p>
    </div>
  </div>
  `,
  styles: [
    `
      .caption {
        height: 145px;
        width: 100%;
      }
      .thumbnail {
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        border-radius: 6px;
        box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.6);
        background-color: #ffffff;
        margin-bottom: 25px;
        max-height: 400px;
        max-width: 300px;
        padding-top: 15px;
        margin-left: auto;
        margin-right: auto;
      }
      .flex-text {
        flex-grow: 1;
      }
      img {
        min-width: 0;
        height: auto;
        max-width: 100%;
      }

      .product-title {
        height: 25px !important;
        width: 202px !important;
        color: #4a4a4a !important;
        font-family: 'LGEIRegular';
        font-size: 18px !important;
        font-weight: bold !important;
        line-height: 25px !important;
        text-align: center !important;
      }

      img[_ngcontent-c5] {
        max-height: 100%;
        margin: auto;
        display: block;
      }

      @media (max-width: 320px){  
        .thumbnail {
          width: 220px !important;
        }
      }
      @media (max-width: 375px) and (min-width:321px){  
        .thumbnail {
          width: 275px !important;
        }
      }
      @media (max-width: 425px) and (min-width:376px){  
        .thumbnail {
          width: 275px !important;
        }
      }
      @media (max-width: 768px) and (min-width:425px) {
        .thumbnail {
          width: 280px !important;
        }
        img {
          max-width: 100% !important;
        }
      }
    `
  ]
})
export class ProductCardComponent implements OnChanges {
  @Input() model: ProductModel;
  @Input() showFamily: Boolean = true;
  @Input() productModelId = '';
  @Input() origprodId = '';
  @Input() productLine: string;
  @Input() categories: CategoryModel[];
  @Input() productClass: string = null;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  currentImageSet: ImageUploadImageSetModel = new ImageUploadImageSetModel();
  productUmbracoUrl = '#';
  hiresproductImage = '';
  desklargeproductImage = '';
  desksmallproductImage = '';
  tabletproductImage = '';
  phoneproductImage = '';
  imageUtil = new ProdcutImageUtil();
  class: string;

  isCommercial(): boolean {
    return this.productLine === 'Commercial';
  }

  ngOnChanges() {
    const productLineParam =
      this.productLine === 'Commercial'
        ? 'commercial'
        : 'residential-light-commercial';
    const isCommerical = this.productLine === 'Commercial' ? 'true' : 'false';

    if (this.productModelId && this.origprodId) {
      this.productUmbracoUrl = `${
        environment.umbracoUrl
      }${productLineParam}/product-type/model-details/accessory-type/?productTypeId=${
        this.origprodId
      }&modelId=${this.productModelId}&accessoryId=${
        this.model.id
      }&iscommercial=${isCommerical}`;
    } else {
      this.productUmbracoUrl = `${
        environment.umbracoUrl
      }${productLineParam}/product-type/?productTypeId=${
        this.model.id
      }&iscommercial=${isCommerical}`;
    }
    if (this.productClass) {
      this.productUmbracoUrl += '&class=' + encodeURI(this.productClass);
    }

    // Add selected Category to url
    if (this.categories) {
      for (const cat of this.categories) {
        if (cat.selected) {
          this.class = cat.name;
          this.productUmbracoUrl += `&class=${encodeURIComponent(cat.name)}`;
        }
      }
    }
    const className = this.imageUtil.translateClassName(this.isCommercial().toString(), this.class);

    if (this.model.images && this.model.images[0]) {
      /*
      this.imageUtil.mapImages(className, this.isCommercial(), this.model.images, this.currentImageSet);
      this.hiresproductImage = this.currentImageSet && this.currentImageSet.highresimage.url ? this.currentImageSet.highresimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.desklargeproductImage = this.currentImageSet && this.currentImageSet.desktoplargeimage.url ? this.currentImageSet.desktoplargeimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.desksmallproductImage = this.currentImageSet && this.currentImageSet.desktopsmallimage.url ? this.currentImageSet.desktopsmallimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.tabletproductImage = this.currentImageSet && this.currentImageSet.tabletimage.url ? this.currentImageSet.tabletimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.phoneproductImage = this.currentImageSet && this.currentImageSet.phoneimage.url ? this.currentImageSet.phoneimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      */
      this.imageUtil.mapImages(className, this.isCommercial(), this.model.images, this.currentImageSet);
      this.hiresproductImage = this.currentImageSet.highresimage.url;
      this.desklargeproductImage = this.currentImageSet.desktoplargeimage.url;
      this.desksmallproductImage = this.currentImageSet.desktopsmallimage.url;
      this.tabletproductImage = this.currentImageSet.tabletimage.url;
      this.phoneproductImage = this.currentImageSet.phoneimage.url;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-card.component.ts